import { render, staticRenderFns } from "./PreliminariNutraukimas.vue?vue&type=template&id=a49d1b5a&scoped=true&"
import script from "./PreliminariNutraukimas.vue?vue&type=script&lang=js&"
export * from "./PreliminariNutraukimas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49d1b5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer})
